import DoormanImage from '../../assets/images/doorman.png';

export function DoormanIcon(props: any) {
  return <img src={DoormanImage} alt="Event icon" {...props} />;
}
